









import { Prop, Component, Vue } from "vue-property-decorator";
import GridCell from "@/models/grid-cell";

@Component({})
export default class VGridRow extends Vue {
  @Prop({ required: true }) cols!: number;
  @Prop({ default: () => [] }) cells!: GridCell[];
}
